import React, { memo, useCallback } from "react";
import { Box, Skeleton, useMediaQuery } from "@mui/material";
import Chip from "@mui/material/Chip";
import Carousel from "react-material-ui-carousel";
import { useNavigate } from "react-router-dom";

import "./HeroPage.styles.scss";
import heroImg from "../../../../assets/images/heroPage_img.png";
import carouselImg from "../../../../assets/images/form_img.png";
import Catalog from "../Catalog/Catalog";

const HeroPage = memo(
  ({
    category,
    categoryLoad,
    popular,
    popularNumber,
    setPopularPage,
    popularPage,
    authenticated,
    recommendations,
    recommendationNumber,
    setRecommendationPage,
    recommendationPage,
  }: any) => {
    const navigate = useNavigate();
    const isMobile = useMediaQuery("(max-width:1000px)");

    let Carouselitems = [
      {
        name: "Артём",
        description: "Бросил офисную работу и стал снимать фестивальное кино.",
      },
      {
        name: "Random Name #2",
        description: "Hello World!",
      },
      {
        name: "Random Name #2",
        description: "Hello World!",
      },
      {
        name: "Random Name #2",
        description: "Hello World!",
      },
      {
        name: "Random Name #2",
        description: "Hello World!",
      },
    ];
    const handleClickChip = (id: string) => {
      navigate(`/search/${id}`);
    };

    const LoadingChips = useCallback(() => {
      return (
        <Skeleton
          variant="rounded"
          width={70 * (Math.random() + 1)}
          height={32}
          className={"chipCard"}
          sx={{
            display: "inline-block",
            borderRadius: "20px",
          }}
        />
      );
    }, []);

    const Chips = () => {
      if (categoryLoad) {
        const ans = [1, 2, 3, 4, 5, 6, 7, 8, 9];
        return ans.map(() => <LoadingChips />);
      } else {
        return category.slice(0, 9).map((el: any) => {
          return (
            <Chip
              key={el.id}
              label={el.name}
              sx={{
                background: "white",
                margin: "0 0 8px 8px",
                cursor: "pointer",
              }}
              className={"chipCard"}
              onClick={() => handleClickChip(el.id)}
            />
          );
        });
      }
    };

    return (
      <Box className={"wrapperFrom"}>
        <Box className={"courseBanner"}>
          <Box className={"courseTitle"}>Обучитесь профессии мечты</Box>
          <img src={heroImg} className={"imgWrp"} alt={"img"} />
          <Box className={"chipWrp"}>
            <Chips />
          </Box>
          <button className={"heroPageBtn"} onClick={() => navigate("/search")}>
            Все курсы
          </button>
        </Box>

        {isMobile && (
          <>
            <Catalog
              card={popular}
              title={"Популярное"}
              total={popularNumber}
              setPage={setPopularPage}
              page={popularPage}
            />

            {authenticated ? (
              <>
                <Catalog
                  card={recommendations}
                  title={"Рекомендовано для вас"}
                  total={recommendationNumber}
                  setPage={setRecommendationPage}
                  page={recommendationPage}
                />
              </>
            ) : null}
          </>
        )}

        <Box>
          <Carousel
            className={"carousel"}
            navButtonsAlwaysInvisible={true}
            indicatorIconButtonProps={{
              style: {
                padding: "2px",
                background: "rgba(192, 220, 248, 1)",
                width: "59px",
                height: "4px",
                borderRadius: "4px",
                margin: "0 4px",
              },
            }}
            activeIndicatorIconButtonProps={{
              style: {
                background: "rgba(5, 115, 228, 1)",
              },
            }}
            indicatorContainerProps={{
              style: {
                marginTop: "-25px",
              },
            }}>
            {Carouselitems.map((item, i) => (
              <Box
                key={i}
                sx={{
                  background: `url(${carouselImg})`,
                  backgroundSize: "cover",
                  height: "340px",
                  borderRadius: "8px",
                  padding: "44px 32px",
                  display: "flex",
                  alignItems: "flex-start",
                  flexDirection: "column",
                  justifyContent: "flex-end",
                  color: "white",
                  //
                  "@media (max-width:1000px)": {
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    height: "343px",
                  },
                }}>
                <Box className={"cardTitle"}>{item.name}</Box>
                <Box>{item.description}</Box>
              </Box>
            ))}
          </Carousel>
        </Box>
      </Box>
    );
  }
);

export default HeroPage;
